/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateTriggerInstanceForm,
  UpdateTriggerInstanceForm$Outbound,
  UpdateTriggerInstanceForm$outboundSchema,
} from "../components/updatetriggerinstanceform.js";

export type UpdateTriggerInstanceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateTriggerInstanceRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateTriggerInstanceForm: UpdateTriggerInstanceForm;
};

/** @internal */
export type UpdateTriggerInstanceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateTriggerInstanceSecurity$outboundSchema: z.ZodMiniType<
  UpdateTriggerInstanceSecurity$Outbound,
  UpdateTriggerInstanceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateTriggerInstanceSecurityToJSON(
  updateTriggerInstanceSecurity: UpdateTriggerInstanceSecurity,
): string {
  return JSON.stringify(
    UpdateTriggerInstanceSecurity$outboundSchema.parse(
      updateTriggerInstanceSecurity,
    ),
  );
}

/** @internal */
export type UpdateTriggerInstanceRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateTriggerInstanceForm: UpdateTriggerInstanceForm$Outbound;
};

/** @internal */
export const UpdateTriggerInstanceRequest$outboundSchema: z.ZodMiniType<
  UpdateTriggerInstanceRequest$Outbound,
  UpdateTriggerInstanceRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateTriggerInstanceForm: UpdateTriggerInstanceForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateTriggerInstanceForm: "UpdateTriggerInstanceForm",
    });
  }),
);

export function updateTriggerInstanceRequestToJSON(
  updateTriggerInstanceRequest: UpdateTriggerInstanceRequest,
): string {
  return JSON.stringify(
    UpdateTriggerInstanceRequest$outboundSchema.parse(
      updateTriggerInstanceRequest,
    ),
  );
}
